import React, { useState } from 'react'
import ToggleSwitch from '../../../ToggleSwitch/ToggleSwitch'

export default function StripePaymentMethods({close, account, proceed, saving}) {
    const [modifiedAccount, setModifiedAccount] = useState(account)

    const toggleIsChecked = (value) => {
        return modifiedAccount.methods.includes(value)
    }

    const updateAccount = (value) => {
        if (modifiedAccount.methods.includes(value)) {
            let methods = modifiedAccount.methods.filter(method => method !== value)
            setModifiedAccount({...modifiedAccount, methods: methods})
            return 
        }

        setModifiedAccount({...modifiedAccount, methods: [...modifiedAccount.methods, value]})
    }

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center" style={{width: '800px'}}>
                <h4>Account Payment Methods</h4>

                <div className='row' style={{textAlign: 'left'}}>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <ToggleSwitch
                                small
                                id="card"
                                checked={true}
                                onChange={(checked) => Alert.show('notice', 'The card option is a requirement and cannot be unselected')}
                            />
                            <label htmlFor="card">Card <small className='text-muted'>(required)</small></label>
                        </div>
                        <div className="form-group">
                            <ToggleSwitch
                                small
                                id="us_bank_account"
                                checked={toggleIsChecked('us_bank_account')}
                                onChange={checked => {updateAccount('us_bank_account')}}
                            />
                            <label htmlFor="us_bank_account">ACH Direct Debit</label>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <ToggleSwitch
                                small
                                id="cashapp"
                                checked={toggleIsChecked('cashapp')}
                                onChange={checked => {updateAccount('cashapp')}}
                            />
                            <label htmlFor="cashapp">Cash App Pay</label>
                        </div>
                    </div>
                </div>

                <div className="pt-3">
                    <button 
                        onClick={() => proceed(modifiedAccount.methods)} 
                        type="button" className="btn btn-primary mr-2" 
                        disabled={saving}
                    >
                        Save
                    </button>

                    <button onClick={close} type="button" className="btn btn-secondary mr-2" disabled={saving}>
                        Close
                    </button>
                </div>

                <small className='text-danger' style={{textAlign: 'center'}} >
                    <b>Note: </b>Ensure the selected payment options here are already enabled on your Stripe account
                </small>
            </div>
        </div>
    </div>
  )
}
